import React from 'react'

import {
  ClockDefault, Icon, InfoOutlined, classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { node, oneOf, string } from 'prop-types'

const ICON_SIZE = { width: '20', height: '20' }

function PlanNotice({
  variant, title, description, action = null,
}) {
  return (
    <div className={classnames('plan-notice', `plan-notice--${variant}`)} role="status">
      <div className="plan-notice__content">
        {variant === 'scheduled' ? (
          <Icon
            svgComponent={ClockDefault}
            size={ICON_SIZE}
            className="plan-notice__icon plan-notice__icon--scheduled"
            notSpaced
          />
        ) : (
          <InfoOutlined
            width="20"
            height="20"
            className={classnames('plan-notice__icon', `plan-notice__icon--${variant}`)}
            aria-hidden="true"
          />
        )}
        <div>
          <p className="cgt-body-md-semibold plan-notice__title">{title}</p>
          <p className="cgt-body-base plan-notice__description">{description}</p>
        </div>
      </div>
      {action && <div className="plan-notice__actions">{action}</div>}
    </div>
  )
}

PlanNotice.propTypes = {
  variant: oneOf(['neutral', 'error', 'warning', 'scheduled']).isRequired,
  title: string.isRequired,
  description: string.isRequired,
  action: node,
}

export default PlanNotice
